import type { ParticipationQuestionnaire } from "./types";

// A questionnaire is translated field by field, any other post as the activity's text
export function translationTarget(
  activityId: string,
  object?: { type?: string; id?: string },
) {
  return object?.type === "questionnaire" && object.id
    ? { types: ["questionnaire"], target_id: object.id }
    : { types: ["activity"], target_id: activityId };
}

export function translateQuestionnaire<T extends ParticipationQuestionnaire>(
  questionnaire: T,
  fields?: Record<string, string>,
): T {
  if (!fields) return questionnaire;

  return {
    ...questionnaire,
    title: fields.title || questionnaire.title,
    description: fields.description || questionnaire.description,
    questions: questionnaire.questions.map((question) => ({
      ...question,
      content: fields[`question_${question.id}`] || question.content,
      options: question.options?.map((option) => ({
        ...option,
        label: fields[`option_${option.id}`] || option.label,
      })),
    })),
  };
}
